webpackJsonp([1],{

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8138c59e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(675);
var normalizeComponent = __webpack_require__(70)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8138c59e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rcv__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styles_scss__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_styles_scss__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App",
  components: {
    "Rcv": __WEBPACK_IMPORTED_MODULE_0__Rcv__["a" /* default */]
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_echarts_core__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_echarts_renderers__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_echarts_charts__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_InstructionComponent__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ButtonComponent__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconComponent__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_chart_config__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_echarts_components__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_app_config__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_echarts__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_echarts__ = __webpack_require__(671);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















Object(__WEBPACK_IMPORTED_MODULE_3_echarts_core__["c" /* use */])([__WEBPACK_IMPORTED_MODULE_4_echarts_renderers__["a" /* CanvasRenderer */], __WEBPACK_IMPORTED_MODULE_5_echarts_charts__["a" /* BarChart */], __WEBPACK_IMPORTED_MODULE_11_echarts_components__["b" /* TitleComponent */], __WEBPACK_IMPORTED_MODULE_11_echarts_components__["c" /* TooltipComponent */], __WEBPACK_IMPORTED_MODULE_11_echarts_components__["a" /* LegendComponent */]]);

var chartConfig = Object(__WEBPACK_IMPORTED_MODULE_10__config_chart_config__["g" /* getChartConfig */])({
  stepValue: this.count,
  hasVotingEnded: false,
  axisdata: this.rowHeader,
  winnerText: this.winnerText
});
var appData = Object(__WEBPACK_IMPORTED_MODULE_12__config_app_config__["a" /* getAppConfig */])();
var ballotWinnerTimer = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Rcv",
  //count ->Current step
  data: function data() {
    return {
      direction: null,
      count: 1,
      final: null,
      updatedOption: [],
      disablestart: false,
      styleProps: null,
      heading: "",
      description: "",
      stepHeadingText: "",
      ofText: "",
      instructionSet: null,
      rowHeader: null,
      winnerText: "",
      buttonLabels: null,
      label: "",
      roundValue: null,
      loader: true,
      chartOptions: null,
      iconColor: [],
      iconName: []
    };
  },

  components: {
    "v-instructions": __WEBPACK_IMPORTED_MODULE_6__components_InstructionComponent__["a" /* default */],
    "v-button": __WEBPACK_IMPORTED_MODULE_7__components_ButtonComponent__["a" /* default */],
    "v-icon": __WEBPACK_IMPORTED_MODULE_8__components_IconComponent__["a" /* default */],
    VChart: __WEBPACK_IMPORTED_MODULE_13_vue_echarts__["a" /* default */]
  },
  watch: {
    count: function count(newCount, oldCount) {
      this.initUpdateOption();
    }
  },
  methods: {
    //On clicking previous ,previous logic is handling here
    onprevious: function onprevious() {
      this.goTo();

      this.disablestart = false;
      this.count = this.count - 1;
      this.direction = "prev";
      if (this.count < 1) {
        this.count = 1;
      }
      //initing the graph with updated changes

      this.initUpdateOption();
    },

    //used to initing the graph with latest option
    initUpdateOption: function initUpdateOption() {
      var _this = this;

      var updatedOption = void 0;
      var eliminatedOpacity = 0.2;
      var afterEliminationOpacity = 0.05;

      updatedOption = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(appData)).map(function (round) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, round, {
          data: round.data.map(function (dataObj, index) {
            if (index == 4) {
              if (_this.count === 3) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this.count === 2) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            if (index === 3) {
              if (_this.count === 4) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this.count === 3) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            if (index === 6) {
              if (_this.count === 5) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this.count === 4) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            if (index === 2) {
              if (_this.count === 6) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: eliminatedOpacity
                });
              }
              if (_this.count === 5) {
                dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                  opacity: 1
                });
              }
            }

            return dataObj;
          })
        });
      });

      if (this.count == 6) {
        ballotWinnerTimer = setTimeout(function () {
          _this.final = true;
          updatedOption = appData.map(function (round) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, round, {
              data: round.data.map(function (dataObj, index) {
                if (index === 1) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    color: __WEBPACK_IMPORTED_MODULE_10__config_chart_config__["b" /* customColors */][1]
                  });
                }
                if (index === 2) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                if (index === 3) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                if (index === 4) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                if (index === 5) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    color: __WEBPACK_IMPORTED_MODULE_10__config_chart_config__["b" /* customColors */][5]
                  });
                }
                if (index === 6) {
                  dataObj.itemStyle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj.itemStyle, {
                    opacity: afterEliminationOpacity
                  });
                }
                return dataObj;
              })
            });
          });
          _this.disablestart = false;
          _this.updateGraph(updatedOption);
        }, 1500);
      }
      if (this.count === 5 && this.direction === "prev") {
        this.final = false;
        updatedOption = appData.map(function (round, index) {
          round.data[1] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, round.data[1], {
            itemStyle: {
              color: __WEBPACK_IMPORTED_MODULE_10__config_chart_config__["j" /* stepFivePurpleColors */][index]
            }
          });
          round.data[5] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, round.data[5], {
            itemStyle: {
              color: __WEBPACK_IMPORTED_MODULE_10__config_chart_config__["i" /* stepFiveOrangeColors */][index]
            }
          });
          return round;
        });
      }
      updatedOption = appData.map(function (round, roundIndex) {
        if (roundIndex > _this.count) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, round, {
            data: round.data.map(function (dataObj) {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, dataObj, {
                value: 0
              });
            })
          });
        }
        return round;
      });

      this.updateGraph(updatedOption);
    },

    //on clicking the next, next logic is handlling here
    onnext: function onnext() {
      this.goTo();
      this.direction = "next";
      this.final = false;

      // this.disablestart = false;
      var vm = this;
      this.count = this.count + 1;
      if (this.count > 5) {
        this.count = 6;
        this.disablestart = true;
      }

      this.initUpdateOption();
    },

    //initializing the initial graph
    initInitialGraph: function initInitialGraph() {
      this.goTo();
      this.disablestart = false;

      this.count = 0;
      this.count = this.count + 1;
      var round0 = Object(__WEBPACK_IMPORTED_MODULE_12__config_app_config__["b" /* getInitialRoundObj */])();
      this.updatedOption = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, round0, { hasVotingEnded: false });
      this.graphInitor();
    },

    goTo: function goTo() {
      var element = document.getElementById("wrapper");
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center"
        });
      }
      //   if (this.$refs.instruction) {
      //     this.$refs.instruction.$el.focus();
      //   }
    },

    //reseting the graph when the start is clicked
    resetGraph: function resetGraph() {
      // this.disablestart = false;
      this.goTo();

      var initialRound = Object(__WEBPACK_IMPORTED_MODULE_12__config_app_config__["b" /* getInitialRoundObj */])();
      appData = Object(__WEBPACK_IMPORTED_MODULE_12__config_app_config__["a" /* getAppConfig */])();
      var chartOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, chartConfig, {
        series: initialRound
      });
      // this.updatedOption = chartOptions;
      this.chart = this.$refs.myEchart;
      this.count = 0;
      this.count = this.count + 1;
      this.chart.setOption({}, true);
      this.chart.setOption(chartOptions, true);
    },

    // initializing the graph with updated option
    updateGraph: function updateGraph(updatedOption) {
      var currentOption = [];
      if (this.count == 1) {
        currentOption = updatedOption.slice(0, this.count);
      } else if (this.count == 6 && this.final == true) {
        currentOption = updatedOption.slice(6, 7);
      } else {
        currentOption = updatedOption.slice(1, this.count);
      }

      var updatedBallotRounds = Object(__WEBPACK_IMPORTED_MODULE_10__config_chart_config__["e" /* formatRounds */])(currentOption, this.count, this.label);

      this.updatedOption = updatedBallotRounds;
      var stepValue = this.count;
      var hasVotingEnded = false;
      if (this.updatedOption[0] != null) {
        hasVotingEnded = this.updatedOption[0].hasVotingEnded;
        if (this.count == 6 && this.final == true) {
          hasVotingEnded = true;
        }
      }

      var axisData = this.rowHeader;
      var winnerText = this.winnerText;
      var chartConfig = Object(__WEBPACK_IMPORTED_MODULE_10__config_chart_config__["g" /* getChartConfig */])({
        stepValue: stepValue,
        hasVotingEnded: hasVotingEnded,
        axisData: axisData,
        winnerText: winnerText
      });
      var updatedOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, chartConfig, {
        series: updatedBallotRounds
      });

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$refs).length > 0) {
        this.chart = this.$refs.myEchart;

        this.chart.setOption(updatedOptions, {
          notMerge: true,
          lazyUpdate: false,
          silent: false
        });
      }
    },

    //initializing the graph with default value
    graphInitor: function graphInitor() {
      var stepValue = this.count;
      var ballotRounds = this.updatedOption;
      var hasVotingEnded = this.updatedOption.hasVotingEnded;
      var chartConfig = Object(__WEBPACK_IMPORTED_MODULE_10__config_chart_config__["g" /* getChartConfig */])({ stepValue: stepValue, hasVotingEnded: hasVotingEnded });
      var chartOptions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, chartConfig, {
        series: ballotRounds
      });

      this.chart = this.$refs.myEchart;
      this.chart.setOption(chartOptions, true);
    }
  },

  created: function created() {
    this.styleProps = __WEBPACK_IMPORTED_MODULE_10__config_chart_config__["h" /* isSmallScreen */] ? { width: "100%", height: "443px" } : { width: "97%", height: "576px" };
    var currentInstance = this;
    var cultureDefault = document.documentElement.lang;
    var culture = document.getElementById("ApplicationCulture").value;
    var recvDemo = document.getElementsByClassName("hdnrcvcontentid")[0].value;
    var url = "";

    if (culture != null) {
      url = location.origin + "/rcvapi/getrcvpracticedemo?pageId=" + recvDemo + "&culture=" + culture;
    } else {
      url = location.origin + "/rcvapi/getrcvpracticedemo?pageId=" + recvDemo + "&culture=" + cultureDefault;
    }

    var axios = __webpack_require__(151);
    currentInstance.axios.get(url, {}).then(function (response) {
      currentInstance.loader = true;
      if (response.status == 200) {
        var responseData = response.data.responseObject;

        currentInstance.heading = responseData.heading;
        currentInstance.description = responseData.description;
        currentInstance.stepHeadingText = responseData.stepHeadingText;
        currentInstance.ofText = responseData.ofText;
        currentInstance.instructionSet = responseData.steps;
        var yCordinates = responseData.rowHeaders.map(function (item) {
          return item.label;
        });
        var roundValue = responseData.steps.map(function (item) {
          return item.stepTitle;
        });
        currentInstance.roundValue = roundValue;
        currentInstance.rowHeader = ["null"].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(yCordinates));
        if (responseData.resultText !== "") {
          var modifiedString = responseData.resultText.replace("\\n", "\n");
          currentInstance.winnerText = modifiedString;
        }

        currentInstance.buttonLabels = responseData.buttonLabels;
        currentInstance.label = responseData.voteText;

        //    let labelColor = responseData.rowHeaders.map(function(item) {
        //     return item.color;
        //   });
        var labelColor = ["#221649", "#4BA3B7", "#367D54", "#FADE4B", "#EB5534", "#ED7ACA"];
        currentInstance.iconColor = labelColor;
        currentInstance.iconName = yCordinates;
        setTimeout(function () {
          currentInstance.initUpdateOption();
          currentInstance.loader = false;
        }, 1000);
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  mounted: function mounted() {
    this.count = 1;
  },
  unmounted: function unmounted() {
    if (ballotWinnerTimer !== undefined) {
      clearTimeout(ballotWinnerTimer);
    }
  }
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InstructionComponent",

  data: function data() {
    return {};
  },

  watch: {
    instruction: function instruction(newinstruction, oldinstruction) {
      this.setFocus();
    }
  },

  props: ["instruction", "disable", "instructioncontent"],

  computed: {
    cssStepValue: function cssStepValue() {
      var cssStepValue = "";
      if (this.instruction == 1) {
        cssStepValue = "stepOne";
      } else if (this.instruction === 6) {
        cssStepValue = "stepSix";
      }
      return cssStepValue;
    },

    startButton: function startButton() {
      return __WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg___default.a;
    },
    nextButton: function nextButton() {
      return __WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg___default.a;
    },
    previousButton: function previousButton() {
      return __WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg___default.a;
    },
    startOverButton: function startOverButton() {
      return __WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg___default.a;
    }
  },

  methods: {
    setFocus: function setFocus() {

      this.$refs.roundtitle.focus();
    }
  }
});

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiIgZmlsbD0iI0VCNTUzNCIvPg0KPHBhdGggZD0iTTMyLjA2MDcgMjMuMDYwN0MzMi42NDY0IDIyLjQ3NDkgMzIuNjQ2NCAyMS41MjUxIDMyLjA2MDcgMjAuOTM5M0wyMi41MTQ3IDExLjM5MzRDMjEuOTI4OSAxMC44MDc2IDIwLjk3OTIgMTAuODA3NiAyMC4zOTM0IDExLjM5MzRDMTkuODA3NiAxMS45NzkyIDE5LjgwNzYgMTIuOTI4OSAyMC4zOTM0IDEzLjUxNDdMMjguODc4NyAyMkwyMC4zOTM0IDMwLjQ4NTNDMTkuODA3NiAzMS4wNzExIDE5LjgwNzYgMzIuMDIwOCAyMC4zOTM0IDMyLjYwNjZDMjAuOTc5MiAzMy4xOTI0IDIxLjkyODkgMzMuMTkyNCAyMi41MTQ3IDMyLjYwNjZMMzIuMDYwNyAyMy4wNjA3Wk0xMCAyMy41SDMxVjIwLjVIMTBWMjMuNVoiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxyZWN0IHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgMCAwIDEgNDIgMCkiIGZpbGw9IiNFQjU1MzQiLz4NCjxwYXRoIGQ9Ik05LjkzOTM0IDIzLjA2MDdDOS4zNTM1NSAyMi40NzQ5IDkuMzUzNTUgMjEuNTI1MSA5LjkzOTM0IDIwLjkzOTNMMTkuNDg1MyAxMS4zOTM0QzIwLjA3MTEgMTAuODA3NiAyMS4wMjA4IDEwLjgwNzYgMjEuNjA2NiAxMS4zOTM0QzIyLjE5MjQgMTEuOTc5MiAyMi4xOTI0IDEyLjkyODkgMjEuNjA2NiAxMy41MTQ3TDEzLjEyMTMgMjJMMjEuNjA2NiAzMC40ODUzQzIyLjE5MjQgMzEuMDcxMSAyMi4xOTI0IDMyLjAyMDggMjEuNjA2NiAzMi42MDY2QzIxLjAyMDggMzMuMTkyNCAyMC4wNzExIDMzLjE5MjQgMTkuNDg1MyAzMi42MDY2TDkuOTM5MzQgMjMuMDYwN1pNMzIgMjMuNUgxMVYyMC41SDMyVjIzLjVaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9zdmc+DQo="

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ButtonComponent",

  data: function data() {
    return {};
  },


  props: ["instruction", "disable", "oftest", "buttonText"],

  computed: {
    cssStepValue: function cssStepValue() {
      var cssStepValue = "";
      if (this.instruction == 1) {
        cssStepValue = "stepOne";
      } else if (this.instruction === 6) {
        cssStepValue = "stepSix";
      }
      return cssStepValue;
    },

    startButton: function startButton() {
      return __WEBPACK_IMPORTED_MODULE_1__assets_button_start_svg___default.a;
    },
    nextButton: function nextButton() {
      return __WEBPACK_IMPORTED_MODULE_0__assets_button_next_svg___default.a;
    },
    previousButton: function previousButton() {
      return __WEBPACK_IMPORTED_MODULE_2__assets_button_previous_svg___default.a;
    },
    startOverButton: function startOverButton() {
      return __WEBPACK_IMPORTED_MODULE_3__assets_button_startover_svg___default.a;
    }
  },

  methods: {
    onprevious: function onprevious(e) {
      this.$emit("onprevious");
    },
    onnext: function onnext() {
      this.$emit("onnext");
    },
    onstart: function onstart() {
      this.$emit("startover");
    },
    onreset: function onreset(e) {
      this.$emit("onreset");
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "IconComponent",

  data: function data() {
    return {
      iconclass: ["noblur", "noblur", "noblur", "noblur", "noblur", "noblur"],
      burstclass: null
    };
  },


  watch: {
    step: function step(newCount, oldCount) {
      this.addClass();
    }
  },

  props: ["step", "colorvalue", "colorname"],

  computed: {},

  methods: {
    addClass: function addClass() {
      if (this.step == 0) {
        this.iconclass = ["noblur", "noblur", "noblur", "noblur", "noblur", "noblur"];
        this.burstclass = null;
      }
      if (this.step == 1) {
        this.iconclass = ["noblur", "noblur", "noblur", "noblur", "noblur", "noblur"];
        this.burstclass = null;
      }
      if (this.step == 2) {
        this.iconclass = ["noblur", "noblur", "noblur", "noblur", "noblur", "noblur"];
        this.burstclass = null;
      }
      if (this.step == 3) {
        this.iconclass = ["noblur", "noblur", "noblur", "blur", "noblur", "noblur"];
        this.burstclass = null;
      }
      if (this.step == 4) {
        this.iconclass = ["noblur", "noblur", "blur", "blur", "noblur", "noblur"];
        this.burstclass = null;
      }
      if (this.step == 5) {
        this.iconclass = ["noblur", "noblur", "blur", "blur", "noblur", "blur"];
        this.burstclass = null;
      }
      if (this.step == 6) {
        this.iconclass = ["noblur", "blur", "blur", "blur", "noblur", "blur"];
        this.burstclass = "burst";
      }
    }
  }
});

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isSmallScreen; });
/* unused harmony export isMediumScreen */
/* unused harmony export isLargeScreen */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return barLabelProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return stepFivePurpleColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return stepFiveOrangeColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fiftyPercentLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return genericProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return emptyDataObj; });
/* harmony export (immutable) */ __webpack_exports__["e"] = formatRounds;
/* harmony export (immutable) */ __webpack_exports__["g"] = getChartConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_person_black_svg__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_person_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_person_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_person_blue_svg__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_person_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_person_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_person_green_svg__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_person_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_person_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_person_orange_svg__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_person_orange_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_person_orange_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_person_pink_svg__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_person_pink_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_person_pink_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_person_yellow_svg__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_person_yellow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_person_yellow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_person_purple_burst_svg__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_person_purple_burst_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_person_purple_burst_svg__);











var type = "bar";
var stack = true;
var colorTransparent = "rgba(255, 255, 255, 0)";
var splitLineColor = "rgba(126, 126, 126, 0.2)";
var fiftyPercentLineColor = "#333";
var axisLabelColor = "#000";
var fontFamily = 'Whyte, sans-serif';

var isSmallScreen = window.innerWidth < 426;
var isMediumScreen = window.innerWidth >= 426 && window.innerWidth < 769;
var isLargeScreen = window.innerWidth >= 769;
var barWidth = isSmallScreen ? 24 : 40;

var barLabelProps = {
  label: {
    fontSize: isSmallScreen || isMediumScreen ? 13 : 18

  }
};

var iconPaths = ["", __WEBPACK_IMPORTED_MODULE_3__assets_person_black_svg___default.a, __WEBPACK_IMPORTED_MODULE_4__assets_person_blue_svg___default.a, __WEBPACK_IMPORTED_MODULE_5__assets_person_green_svg___default.a, __WEBPACK_IMPORTED_MODULE_8__assets_person_yellow_svg___default.a, __WEBPACK_IMPORTED_MODULE_6__assets_person_orange_svg___default.a, __WEBPACK_IMPORTED_MODULE_7__assets_person_pink_svg___default.a, __WEBPACK_IMPORTED_MODULE_9__assets_person_purple_burst_svg___default.a];

var customColors = ["rgba(255, 255, 255, 0)", "#221649", // Purple
"#4BA3B7", // Blue
"#367D54", // Green
"#FADE4B", // Yellow
"#EB5534", // Orange
"#ED7ACA" // Pink
];

var stepFivePurpleColors = [customColors[1], customColors[1], customColors[4], customColors[3], customColors[6], customColors[2]];

var stepFiveOrangeColors = [customColors[5], customColors[5], customColors[4], customColors[3], customColors[6], customColors[2]];

var fiftyPercentLine = {
  silent: true,
  lineStyle: {
    color: fiftyPercentLineColor,
    type: "dashed",
    width: 3,
    opacity: 0.15
  },
  label: {
    show: false
  },
  symbolSize: 0,
  data: [{
    symbolOffset: [5, 5],
    y: 10,
    xAxis: 50
  }],
  animation: false
};

var genericProps = {
  type: type,
  barWidth: barWidth,
  stack: stack,
  silent: true,
  animation: true,
  animationEasing: "circularOut",
  animationEasingUpdate: "circularOut",
  animationDuration: 1000,
  animationDelay: function animationDelay(idx) {
    return idx * 75;
  },
  animationDelayUpdate: function animationDelayUpdate(idx) {
    return idx * 50;
  }
};
var emptyDataObj = {
  value: null,
  itemStyle: {
    color: colorTransparent
  }
};

var iconStyleNames = ["", "purple", "blue", "green", "yellow", "orange", "pink", "purpleBurst"];

var iconFadeStyleNames = ["", "purpleFade", "blueFade", "greenFade", "yellowFade", "orangeFade", "pinkFade", "purpleBurstFade"];

var iconSpaces = {
  sm: ["", "                  ", "                  ", "                  ", "                  ", "                  ", "                  ", "          "],
  md: ["", "    ", "    ", "    ", "    ", "   ", "   ", "  "]
};
var iconTextSpaces = {
  sm: ["", "          ", "              ", "           ", "          ", "        ", "              ", "        "],
  md: ["", "     ", "         ", "      ", "     ", "    ", "          ", " "]
};

function getIconStyles(hasVotingEnded) {
  var iconStyleProps = {};
  var iconFadeStyleProps = {};
  var textFade = {
    opacity: hasVotingEnded ? 0.05 : 0.2,
    fontWeight: 700,
    fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
    fontFamily: fontFamily
  };

  iconPaths.forEach(function (iconPath, i) {
    var burstIconHeightLarge = 50;
    var burstIconHeightSmall = 42;
    var iconHeightLarge = 22;
    var iconHeightSmall = 17;
    var iconHeight = void 0;
    var iconBurstHeight = void 0;

    if (isSmallScreen || isMediumScreen) {
      iconHeight = iconHeightSmall;
      iconBurstHeight = burstIconHeightSmall;
    } else {
      iconHeight = iconHeightLarge;
      iconBurstHeight = burstIconHeightLarge;
    }

    var updatedIconStyleProps = {
      backgroundColor: {
        image: iconPath
      },
      height: i === 7 ? iconBurstHeight : iconHeight,
      align: "right"
    };
    iconStyleProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, iconStyleProps, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, iconStyleNames[i], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, updatedIconStyleProps)));
    iconFadeStyleProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, iconFadeStyleProps, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, iconFadeStyleNames[i], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, updatedIconStyleProps, textFade)));
  });
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, iconStyleProps, iconFadeStyleProps, { textFade: textFade });
}

function formatRounds(ballotRounds, stepValue, label) {
  var labelPosition = "right";
  var labelDistance = 15;
  var isLabelShown = false;
  var labelLayout = {
    hideOverlap: true,
    x: 10,
    dy: -6
  };
  var brLen = ballotRounds.length - 1;
  return ballotRounds.map(function (round, roundIndex) {
    var getSum = function getSum(series) {
      return function (param) {
        var sum = 0;
        series.forEach(function (seriesDatum) {
          sum += seriesDatum.data[param.dataIndex].value;
        });
        return param.dataIndex === 0 ? "" : sum + " " + label;
      };
    };
    if (isSmallScreen) {
      labelPosition = "bottom";
    }
    if (isMediumScreen || isLargeScreen) {
      labelLayout = {
        hideOverlap: true
      };
    }
    if (stepValue === 2 || roundIndex === brLen) {
      isLabelShown = true;
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(round, {
      label: {
        fontFamily: fontFamily,
        show: isLabelShown,
        formatter: stepValue === 1 ? "" : getSum(ballotRounds),
        position: labelPosition,
        distance: labelDistance

      },

      labelLayout: labelLayout
    });
  });
}

function getChartConfig(_ref) {
  var stepValue = _ref.stepValue,
      hasVotingEnded = _ref.hasVotingEnded,
      axisData = _ref.axisData,
      winnerText = _ref.winnerText;


  var chartConfig = {

    title: {
      show: hasVotingEnded ? true : false,
      text: winnerText, //winnerText,
      left: isSmallScreen ? "0%" : "17%",
      top: isSmallScreen || isMediumScreen ? "37%" : "38%",

      textStyle: {
        fontFamily: fontFamily,
        lineHeight: 42,
        color: customColors[1],
        fontWeight: 800,
        fontSize: isSmallScreen || isMediumScreen ? 26 : 36
      }
    },
    grid: {
      left: isSmallScreen ? 1 : 10,
      right: "5%",
      bottom: "5%",
      top: "-14%",
      height: isSmallScreen ? 505 : 645,
      width: isSmallScreen ? "106%" : "100%",
      containLabel: true
    },
    xAxis: {
      type: "value",
      inverse: false, // bar reverse line
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily: fontFamily,
        color: "black",
        fontSize: isSmallScreen || isMediumScreen ? 14 : 18,
        padding: isSmallScreen || isMediumScreen ? [10, 0, 0, 10] : [15, 0, 0, 10],
        formatter: function formatter(value, index) {
          if (isSmallScreen && index === 3) {
            return "";
          }
          if ((isMediumScreen || isLargeScreen) && index === 7) {
            return "";
          }
          return value + "%";
        }
      },
      interval: isSmallScreen ? 25 : 10,
      min: 0,
      max: isSmallScreen ? 60 : 70
    },
    yAxis: {
      type: "category",
      offset: 5,
      splitLine: {
        show: true,
        lineStyle: {
          width: 3,
          color: splitLineColor
        }
      },
      inverse: true,
      data: axisData,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontFamily: fontFamily,
        color: axisLabelColor,
        fontSize: isSmallScreen || isMediumScreen ? 14 : 21,
        fontWeight: "bolder",
        formatter: function formatter(axisLabel, axisIndex) {
          //   if (isSmallScreen) {
          //     if (axisIndex === 2) {
          //       if (stepValue >= 6) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}

          //   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}` 
          //         ];
          //       }
          //     }
          //     if (axisIndex === 3) {
          //       if (stepValue >= 4) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}

          //   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}`
          //         ];
          //       }
          //     }
          //     if (axisIndex === 4) {
          //       if (stepValue >= 3) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}

          //   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}`
          //         ];
          //       }
          //     }
          //     if (axisIndex === 6) {
          //       if (stepValue >= 5) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}

          //   {textFade|${axisLabel}}${iconTextSpaces.sm[axisIndex]}`
          //         ];
          //       }
          //     }
          //     if (hasVotingEnded && axisIndex === 1) {
          //       return [
          //         `{${iconStyleNames[7]}|}${iconSpaces.sm[7]}
          //   ${axisLabel}${iconTextSpaces.sm[7]}`
          //       ];
          //     }

          //     return [
          //       `{${iconStyleNames[axisIndex]}|}${iconSpaces.sm[axisIndex]}

          // 	  ${axisLabel}${iconTextSpaces.sm[axisIndex]}`
          //     ];
          //   } else {
          //     if (axisIndex === 2) {
          //       if (stepValue >= 6) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
          //         ];
          //       }
          //     }
          //     if (axisIndex === 3) {
          //       if (stepValue >= 4) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
          //         ];
          //       }
          //     }
          //     if (axisIndex === 4) {
          //       if (stepValue >= 3) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
          //         ];
          //       }
          //     }
          //     if (axisIndex === 6) {
          //       if (stepValue >= 5) {
          //         return [
          //           `{${iconFadeStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}{textFade|${axisLabel}}${iconTextSpaces.md[axisIndex]}`
          //         ];
          //       }
          //     }
          //     if (hasVotingEnded && axisIndex === 1) {
          //       return [
          //         `{${iconStyleNames[7]}|}${iconSpaces.md[7]}${axisLabel}${iconTextSpaces.md[7]}`
          //       ];
          //     }

          //     return [
          //       `{${iconStyleNames[axisIndex]}|}${iconSpaces.md[axisIndex]}${axisLabel}${iconTextSpaces.md[axisIndex]}`
          //     ];
          //   }
        },

        verticalAlign: "middle",
        // textAlign: "right",
        rich: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, getIconStyles(hasVotingEnded))
      }
    }
  };

  return chartConfig;
}

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rcv_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5645285d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rcv_vue__ = __webpack_require__(672);
var normalizeComponent = __webpack_require__(70)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rcv_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5645285d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rcv_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionComponent_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85306784_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionComponent_vue__ = __webpack_require__(535);
var normalizeComponent = __webpack_require__(70)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstructionComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85306784_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstructionComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"roundtitle",staticClass:"instructions",attrs:{"tabindex":"0"}},[(this.instruction)?_c('div',[(_vm.instructioncontent[this.instruction - 1])?_c('div',[(_vm.instructioncontent[this.instruction - 1].stepTitle !== undefined)?_c('div',[_c('h5',[_vm._v("\n          "+_vm._s(_vm.instructioncontent[this.instruction - 1].stepTitle)+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.instructioncontent[this.instruction - 1].content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.instructioncontent[this.instruction - 1].content)}}):_vm._e()]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonComponent_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375c9b68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonComponent_vue__ = __webpack_require__(537);
var normalizeComponent = __webpack_require__(70)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_375c9b68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonGroup",class:_vm.cssStepValue},[_c('div',{staticClass:"buttonGroup-Inner"},[(_vm.instruction == 1)?_c('button',{staticClass:"startButton",attrs:{"alt":"start ballot","width":"120px","src":_vm.startButton},on:{"click":_vm.onnext}},[(_vm.buttonText.start)?_c('span',[_vm._v(_vm._s(_vm.buttonText.start))]):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.instruction > 1 && _vm.instruction < 6) || _vm.instruction == 6)?_c('button',{staticClass:"prev",attrs:{"disabled":_vm.disable,"alt":"previous round","width":"30px","src":_vm.previousButton},on:{"click":function($event){return _vm.onprevious($event)}}},[_vm._v("\n        Previous\n      ")]):_vm._e(),_vm._v(" "),(_vm.instruction == 6)?_c('button',{staticClass:"startover",attrs:{"alt":"startover ballot","width":"120px","src":_vm.startOverButton,"disabled":_vm.disable},on:{"click":function($event){return _vm.onreset($event)}}},[(_vm.buttonText.startOver)?_c('span',[_vm._v(_vm._s(_vm.buttonText.startOver))]):_vm._e()]):_vm._e(),_vm._v(" "),(this.instruction && this.oftest)?_c('div',{staticClass:"roundsLabel"},[_vm._v("\n        "+_vm._s(this.instruction)+" "+_vm._s(this.oftest)+" 6\n      ")]):_vm._e(),_vm._v(" "),(_vm.instruction > 1 && _vm.instruction < 6)?_c('button',{staticClass:"next",attrs:{"alt":"next round","width":"30px","src":_vm.nextButton},on:{"click":_vm.onnext}},[_vm._v("\n        Next\n      ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconComponent_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f65d420_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconComponent_vue__ = __webpack_require__(539);
var normalizeComponent = __webpack_require__(70)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IconComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f65d420_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IconComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-left-panel"},[(_vm.colorvalue)?_c('div',_vm._l((_vm.colorvalue),function(item,index){return _c('div',{key:item,staticClass:"left-panel__item red-color",class:_vm.iconclass[index]},[_c('div',{staticClass:"icon-hold"},[_c('svg',{attrs:{"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 24"}},[_c('path',{staticClass:"color",attrs:{"d":"M11 12a6.16 6.16 0 006.29-6A6.16 6.16 0 0011 0a6.16 6.16 0 00-6.29 6A6.16 6.16 0 0011 12zm4.4 1.5h-.82a8.92 8.92 0 01-7.16 0H6.6A6.46 6.46 0 000 19.8v1.95A2.31 2.31 0 002.36 24h17.28A2.31 2.31 0 0022 21.75V19.8a6.46 6.46 0 00-6.6-6.3z","fill":item}})])]),_vm._v(" "),(index == 0 && _vm.step == 6)?_c('div',{staticClass:"burst-bg"},[_c('svg',{attrs:{"width":"42","height":"43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M21 43l-6.494-12.834L0 28.104l10.493-9.987-2.468-14.11L21 10.67l12.975-6.662-2.482 14.11L42 28.104l-14.52 2.062L21 43z","fill":"#FEF74F"}}),_vm._v(" "),_c('path',{attrs:{"d":"M21 0l-6.494 12.834L0 14.896l10.493 9.986-2.468 14.11L21 32.331l12.975 6.661-2.482-14.11L42 14.896l-14.52-2.062L21 0z","fill":"#FEF74F"}})])]):_vm._e(),_vm._v(" "),(_vm.colorname)?_c('div',{staticClass:"content-text"},[_c('h5',[_vm._v(_vm._s(_vm.colorname[index]))])]):_vm._e()])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiMyMjE0NEEiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiM0QkEzQjciLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiMzNjdENTQiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiNFQjU1MzQiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiNFRDdBQ0EiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xMSAxMkMxNC40NzE5IDEyIDE3LjI4NTcgOS4zMTQwNiAxNy4yODU3IDZDMTcuMjg1NyAyLjY4NTk0IDE0LjQ3MTkgMCAxMSAwQzcuNTI4MTMgMCA0LjcxNDI5IDIuNjg1OTQgNC43MTQyOSA2QzQuNzE0MjkgOS4zMTQwNiA3LjUyODEzIDEyIDExIDEyWk0xNS40IDEzLjVIMTQuNTc5OUMxMy40ODk3IDEzLjk3ODEgMTIuMjc2OCAxNC4yNSAxMSAxNC4yNUM5LjcyMzIxIDE0LjI1IDguNTE1MTggMTMuOTc4MSA3LjQyMDA5IDEzLjVINi42QzIuOTU2MjUgMTMuNSAwIDE2LjMyMTkgMCAxOS44VjIxLjc1QzAgMjIuOTkyMiAxLjA1NTggMjQgMi4zNTcxNCAyNEgxOS42NDI5QzIwLjk0NDIgMjQgMjIgMjIuOTkyMiAyMiAyMS43NVYxOS44QzIyIDE2LjMyMTkgMTkuMDQzNyAxMy41IDE1LjQgMTMuNVoiIGZpbGw9IiNGQURFNEIiLz4NCjwvc3ZnPg0K"

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iNTkiIHZpZXdCb3g9IjAgMCA1NyA1OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yOC4xNDg0IC0wLjAwMDk5OTQ1MUwzNC43NzE2IDIwLjM4M0g1Ni4yMDQ2TDM4Ljg2NDkgMzIuOTgxTDQ1LjQ4ODEgNTMuMzY1TDI4LjE0ODQgNDAuNzY3TDEwLjgwODggNTMuMzY1TDE3LjQzMTkgMzIuOTgxTDAuMDkyMzAwNCAyMC4zODNIMjEuNTI1M0wyOC4xNDg0IC0wLjAwMDk5OTQ1MVoiIGZpbGw9IiNGREY3NTEiLz4NCjxwYXRoIGQ9Ik0xMS4wMTIgNS40ODcxTDI4LjI0NDMgMTguMjMxNEw0NS42OTAxIDUuNzgwN0wzOC44OTQ1IDI2LjEwNzlMNTYuMTI2OSAzOC44NTIzTDM0LjY5NDcgMzguNjcwOEwyNy44OTkxIDU4Ljk5OEwyMS40NDg4IDM4LjU1ODZMMC4wMTY1OTk3IDM4LjM3NzFMMTcuNDYyMyAyNS45MjY0TDExLjAxMiA1LjQ4NzFaIiBmaWxsPSIjRkRGNzUxIi8+DQo8cGF0aCBkPSJNMjguNjQ4NCAyOUMzMi4xMjAzIDI5IDM0LjkzNDIgMjYuMzE0MSAzNC45MzQyIDIzQzM0LjkzNDIgMTkuNjg1OSAzMi4xMjAzIDE3IDI4LjY0ODQgMTdDMjUuMTc2NiAxNyAyMi4zNjI3IDE5LjY4NTkgMjIuMzYyNyAyM0MyMi4zNjI3IDI2LjMxNDEgMjUuMTc2NiAyOSAyOC42NDg0IDI5Wk0zMy4wNDg0IDMwLjVIMzIuMjI4M0MzMS4xMzgyIDMwLjk3ODEgMjkuOTI1MiAzMS4yNSAyOC42NDg0IDMxLjI1QzI3LjM3MTcgMzEuMjUgMjYuMTYzNiAzMC45NzgxIDI1LjA2ODUgMzAuNUgyNC4yNDg0QzIwLjYwNDcgMzAuNSAxNy42NDg0IDMzLjMyMTkgMTcuNjQ4NCAzNi44VjM4Ljc1QzE3LjY0ODQgMzkuOTkyMiAxOC43MDQyIDQxIDIwLjAwNTYgNDFIMzcuMjkxM0MzOC41OTI2IDQxIDM5LjY0ODQgMzkuOTkyMiAzOS42NDg0IDM4Ljc1VjM2LjhDMzkuNjQ4NCAzMy4zMjE5IDM2LjY5MjIgMzAuNSAzMy4wNDg0IDMwLjVaIiBmaWxsPSIjMjIxNDRBIi8+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialRoundObj;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_chart_config__ = __webpack_require__(257);



function getInitialRoundObj() {
	var initialRound = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r0"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["f" /* genericProps */], {
		markLine: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["d" /* fiftyPercentLine */],
		data: [{
			value: 65,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][0],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][1],
				opacity: 1,
				borderWidth: 0

			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][2],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][3],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][4],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][5],
				opacity: 1
			},
			label: {
				show: false
			}
		}, {
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][6],
				opacity: 1
			},
			label: {
				show: false
			}
		}]
	});
	return initialRound;
}

function getAppConfig() {
	var round0 = getInitialRoundObj();
	var appData = [round0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r1"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["f" /* genericProps */], {
		markLine: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["d" /* fiftyPercentLine */],
		animationDelay: null,
		animationDelayUpdate: null,
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 25, //25
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][1],
				label: {
					show: true
				}

			}

		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 15, //15
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 10, //10
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 5, //5
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 30, //30
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][5]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 15, //15
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][6]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r2"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 2,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 2,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][4]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r3"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 5,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 3,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 1,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][3]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r4"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 14,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][6]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 2,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][6]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r5"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["f" /* genericProps */], {
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 6,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 11,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 0,
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */])]
	}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		name: "r6"
	}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["f" /* genericProps */], {
		markLine: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["d" /* fiftyPercentLine */],
		hasVotingEnded: true,
		animation: false,
		data: [__WEBPACK_IMPORTED_MODULE_1__config_chart_config__["c" /* emptyDataObj */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 52,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][2]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 17,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][2]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 10,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][3]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 5,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][4]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 48,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][5]
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
			value: 16,
			itemStyle: {
				color: __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["b" /* customColors */][6]
			},
			label: {
				show: true
			}
		}, __WEBPACK_IMPORTED_MODULE_1__config_chart_config__["a" /* barLabelProps */])]
	})];
	return appData;
}

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loader),expression:"!loader"}]},[_c('div',{staticClass:"rcv_header"},[(_vm.heading)?_c('h3',[_vm._v(_vm._s(_vm.heading))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"rcv"},[_c('div',{staticClass:"title"},[(_vm.count)?_c('div',[_c('p',[_vm._v("\n            "+_vm._s(_vm.count === 1 ? ("" + _vm.stepHeadingText) : ("" + (_vm.roundValue[_vm.count - 1])))+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('div',{staticClass:"barchart-icon"},[_c('v-icon',{attrs:{"step":this.count,"colorvalue":_vm.iconColor,"colorname":_vm.iconName}})],1),_vm._v(" "),_c('div',{staticClass:"barChart"},[_c('v-chart',{ref:"myEchart",staticClass:"chart",style:(_vm.styleProps),attrs:{"autoresize":true,"option":_vm.chartOptions}})],1),_vm._v(" "),_c('div',{staticClass:"buttongroup-primary",attrs:{"aria-hidden":"true"}},[(_vm.buttonLabels)?_c('v-button',{attrs:{"instruction":this.count,"disable":_vm.disablestart,"oftest":_vm.ofText,"buttonText":_vm.buttonLabels},on:{"onprevious":_vm.onprevious,"onnext":_vm.onnext,"startover":_vm.initInitialGraph,"onreset":_vm.resetGraph}}):_vm._e()],1)]),_vm._v(" "),(_vm.instructionSet)?_c('v-instructions',{ref:"instruction",attrs:{"instruction":this.count,"disable":_vm.disablestart,"instructioncontent":_vm.instructionSet}}):_vm._e(),_vm._v(" "),(_vm.buttonLabels)?_c('v-button',{attrs:{"instruction":this.count,"disable":_vm.disablestart,"oftest":_vm.ofText,"buttonText":_vm.buttonLabels},on:{"onprevious":_vm.onprevious,"onnext":_vm.onnext,"startover":_vm.initInitialGraph,"onreset":_vm.resetGraph}}):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loader),expression:"loader"}]},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"dot-loader"}),_vm._v(" "),_c('div',{staticClass:"dot-loader dot-loader--2"}),_vm._v(" "),_c('div',{staticClass:"dot-loader dot-loader--3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{},[_c('Rcv')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(159);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'App',
    component: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }]
}));

/***/ })

},[281]);


// WEBPACK FOOTER //
// static/js/app.f712de116a6d0efb9bd2.js